<template>
  <div>
    <ErrorsAlert :errors="errors" />

    <!-- Tabs -->
    <div class="con-vs-tabs vs-tabs vs-tabs-primary vs-tabs-position-top">
      <div class="con-ul-tabs">
        <ul class="ul-tabs vs-tabs--ul ul-tabs-left">
          <!-- Tab: Dados Gerais -->
          <li class="vs-tabs--li" :class="passo == 0 ? 'activeChild' : ''">
            <button @click="passo = 0" type="button" class="vs-tabs--btn">
              <span>Dados Gerais</span>
            </button>
          </li>

          <!-- Tab: Resumo -->
          <li
            v-if="passoAtual"
            class="vs-tabs--li"
            :class="passo == 1 ? 'activeChild' : ''"
          >
            <button @click="passo = 1" type="button" class="vs-tabs--btn">
              <span>Inconsistências</span>
            </button>
          </li>

          <!-- Tab: Dados da Cobranças -->
          <li
            v-if="passoAtual == 2"
            class="vs-tabs--li"
            :class="passo == 2 ? 'activeChild' : ''"
          >
            <button @click="passo = 2" type="button" class="vs-tabs--btn">
              <span>Resumo</span>
            </button>
          </li>
        </ul>
      </div>
    </div>

    <!-- Dados Gerais -->
    <div :class="passo == 0 ? 'div-show' : 'div-hide'">
      <form role="form" @submit.stop.prevent="onSubmit">
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/3 w-full mb-3">
            <vs-select
              v-if="carteirasCobranca"
              v-model="formCadastro.idCarteiraCobranca"
              id="Carteira de Cobrança"
              label="Carteira de Cobrança"
              class="select-large w-full"
              name="Carteira de Cobrança"
              v-validate="{ required: true }"
              :state="
                validateState(veeFields, veeErrors, 'Carteira de Cobrança')
              "
              :class="
                validateStateClass(veeFields, veeErrors, 'Carteira de Cobrança')
              "
              :disabled="cobrancasGeradas"
            >
              <vs-select-item :key="0" :value="null" :text="'Selecione'" />
              <vs-select-item
                :key="index + 1"
                :value="item.id"
                :text="`${item.label}`"
                v-for="(item, index) in carteirasCobranca"
              />
            </vs-select>
          </div>
          <div class="vx-col sm:w-1/3 w-full mb-3">
            <label for class="vs-input--label">Mês Referência Cobranças</label>
            <datepicker
              :minimumView="'month'"
              :maximumView="'year'"
              calendar-class="classeDoCalendario"
              label-placeholder="Mês Referencia Boletos"
              name="Mês Referencia Boletos"
              id="Mês Referencia Boletos"
              input-class="inputData w-full large"
              :format="'MM/yyyy'"
              label="MM/YYYY"
              :language="languages['ptBR']"
              v-model="formCadastro.mesReferenciaCobranca"
              :state="
                validateState(veeFields, veeErrors, 'Mês Referencia Boletos')
              "
              :class="
                validateStateClass(
                  veeFields,
                  veeErrors,
                  'Mês Referencia Boletos',
                )
              "
              @input="preencheDatasReferencias"
              :disabled="cobrancasGeradas"
            ></datepicker>
          </div>
          <div class="vx-col sm:w-1/3 w-full mb-3">
            <label for class="vs-input--label">Mês Vencimento Cobranças</label>
            <datepicker
              :minimumView="'month'"
              :maximumView="'year'"
              :disabled-dates="disabledDates"
              calendar-class="classeDoCalendario"
              label-placeholder="Mês Vencimento Boletos"
              name="Mês Vencimento Boletos"
              id="Mês Vencimento Boletos"
              input-class="inputData w-full large"
              :format="'MM/yyyy'"
              label="MM/YYYY"
              :language="languages['ptBR']"
              v-model="formCadastro.mesVencimentoCobranca"
              :state="
                validateState(veeFields, veeErrors, 'Mês Vencimento Boletos')
              "
              :class="
                validateStateClass(
                  veeFields,
                  veeErrors,
                  'Mês Vencimento Boletos',
                )
              "
            ></datepicker>
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/3 w-full mb-3">
            <vs-select
              v-model="formCadastro.statusApolicesParticipantes"
              label="Status Apólices Participantes"
              class="select-large w-full"
              name="Status Apólices Participantes"
              multiple
              :state="
                validateState(
                  veeFields,
                  veeErrors,
                  'Status Apólices Participantes',
                )
              "
              :class="
                validateStateClass(
                  veeFields,
                  veeErrors,
                  'Status Apólices Participantes',
                )
              "
              v-validate="{ required: true }"
              :disabled="cobrancasGeradas"
            >
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="item.label"
                v-for="(item, index) in statusApolice"
              />
            </vs-select>
          </div>
          <div class="vx-col sm:w-1/3 w-full mb-3">
            <vs-select
              v-if="diasVencimento.length > 0"
              v-model="formCadastro.diasVencimento"
              id="Dias de Vencimento"
              label="Dias de Vencimento"
              class="select-large w-full"
              name="Dias de Vencimento"
              multiple
              v-validate="{ required: true }"
              :state="validateState(veeFields, veeErrors, 'Dias de Vencimento')"
              :class="
                validateStateClass(veeFields, veeErrors, 'Dias de Vencimento')
              "
              :disabled="cobrancasGeradas"
            >
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="`${item.label}`"
                v-for="(item, index) in diasVencimento"
              />
            </vs-select>
          </div>
          <div class="vx-col sm:w-1/3 w-full mb-3">
            <label for class="vs-input--label">Cadastrados Até</label>
            <datepicker
              input-class="inputData w-full large"
              :format="'dd/MM/yyyy'"
              label="DD/MM/YYYY"
              v-model="formCadastro.cadastrosAte"
              v-validate="{
                required: true,
                min: 10,
                date_format: 'dd/MM/yyyy',
              }"
              :monday-first="true"
              :auto-placement="true"
              :language="languages['ptBR']"
              calendar-class="classeDoCalendario"
              name="Cadastrados Até"
              :state="validateState(veeFields, veeErrors, 'Cadastrados Até')"
              :danger="
                validateStateClass(veeFields, veeErrors, 'Cadastrados Até')
              "
              :disabled="cobrancasGeradas"
            ></datepicker>
          </div>
        </div>

        <div v-if="!cobrancasGeradas" class="vx-row">
          <div class="vx-col w-full text-right mt-5">
            <vs-button
              color="warning"
              type="border"
              class="mr-3 mb-2"
              @click.stop.prevent="onReset"
              >Cancelar</vs-button
            >

            <BotaoSubmit
              variant="success"
              :edit="dados.id == null ? false : true"
              :aguarde="aguardeCadastro"
            ></BotaoSubmit>
          </div>
        </div>
      </form>
    </div>

    <!-- Resumo -->
    <div :class="passo == 1 ? 'div-show' : 'div-hide'" id="container-modal">
      <h4 class="mt-5">Inconsistências</h4>
      <vs-alert
        v-if="criticas.length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        Corrija as inconsistências abaixo antes de prosseguir.
      </vs-alert>
      <vs-alert
        v-else
        color="primary"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        Nenhuma inconsistência encontrada, prossiga para gerar o fechamento.
      </vs-alert>

      <table v-if="criticas.length > 0" class="table-bordered">
        <tr>
          <th>Inconsistência</th>
          <th>Quantidade</th>
          <th>Detalhes</th>
        </tr>
        <tr v-for="item in criticas" :key="item.id">
          <td>
            {{ item.tipo }}
          </td>
          <td>
            {{ item.qtd }}
          </td>
          <td>
            <a
              href="javascript:void(0)"
              @click="exibeResultadoCritica(item)"
              class="vs-button d-inline vs-button-dark vs-button-gradient includeIcon includeIconOnly vs-radius"
            >
              <feather-icon icon="SearchIcon" svgClasses="h-4 w-4" />
            </a>
          </td>
        </tr>
      </table>
      <div v-if="resultadoCritica.length > 0">
        <h5 class="my-3">Detatlhes Inconsistência - {{ titleCritica }}</h5>
        <table class="table-bordered">
          <tr>
            <th>Código do Segurado</th>
            <th>Segurado</th>
            <th>Tipo da Apólice</th>
            <th>Inconsistências</th>
          </tr>
          <tr v-for="item in resultadoCritica" :key="item.id">
            <td>
              {{ item.seguradoId }}
              <router-link
                target="_blank"
                :to="`/DetalheSegurado/${item.seguradoId}`"
              >
                <feather-icon icon="ExternalLinkIcon" svgClasses="h-4 w-4" />
              </router-link>
            </td>
            <td>
              {{ item.segurado }}
            </td>
            <td>
              {{ item.tipoApolice }}
            </td>
            <td>
              <p
                v-for="(inconsistencia, index) in item.inconsistencias"
                :key="index"
              >
                {{ inconsistencia.chave }}: {{ inconsistencia.valor }}
              </p>
            </td>
          </tr>
        </table>
      </div>

      <div v-if="!cobrancasGeradas" class="vx-row mb-4">
        <div class="vx-col sm:w-1/1 w-full mb-3 text-right">
          <vs-button
            v-if="criticas.length > 0"
            color="warning"
            type="border"
            class="mr-3 mt-3"
            @click="onSubmit"
            >Atualizar</vs-button
          >
          <vs-button
            v-if="criticas.length > 0"
            color="success"
            class="mt-3"
            @click="conferenciaDeValores"
            :disabled="true"
            >Prosseguir</vs-button
          >
          <vs-button
            v-else
            color="success"
            class="mt-3"
            @click="conferenciaDeValores"
            >Prosseguir</vs-button
          >
        </div>
      </div>
    </div>

    <!-- Dados da Cobrança -->
    <div :class="passo == 2 ? 'div-show' : 'div-hide'">
      <AlertNoneRateios class="my-3" v-if="cobrancasFechamento.length === 0" />
      <AlertConsolidado class="my-3" v-else :data-consolidado="consolidado" />

      <div class="vx-row mb-4 mt-3">
        <div class="vx-col sm:w-1/1 w-full mb-3">
          <table class="table-bordered mt-3">
            <tr>
              <th>Segurado</th>
              <th>Apólice</th>
              <th>Status</th>
              <th>Forma de Pagamento</th>
              <th>Vencimento</th>
              <th>Valor</th>
              <th>Parcela</th>
              <th>Cobrança</th>
            </tr>
            <tr v-for="item in cobrancasFechamento" :key="item.id">
              <td>
                {{ item.segurado }}
                <router-link
                  target="_blank"
                  :to="`/DetalheSegurado/${item.segurado_id}`"
                >
                  <feather-icon icon="ExternalLinkIcon" svgClasses="h-4 w-4" />
                </router-link>
              </td>
              <td>
                {{ item.apolice }}
              </td>
              <td>
                {{ item.status_apolice }}
              </td>
              <td>
                {{ item.pagamento }}
              </td>
              <td>
                {{ item.vencimento }}
              </td>
              <td>
                {{ item.valor | currency }}
              </td>
              <td>
                {{ item.parcela }}
              </td>
              <td>
                <vs-chip
                  v-if="item.badge"
                  :color="item.badge.COR"
                  class="product-order-status"
                  >{{ item.badge.STATUS }}</vs-chip
                >
              </td>
            </tr>
          </table>
        </div>
      </div>

      <div v-if="cobrancasGeradas" class="vx-row">
        <div class="vx-col sm:w-1/1 w-full text-center">
          <vs-alert active="true" class="my-3" style="height: auto !important">
            <span class=""
              >Ordem de cobrança criada dia
              {{
                formataDataHoraPadraoBR(
                  formCadastro.data_geracao_cobrancas,
                  false,
                )
              }}</span
            >
          </vs-alert>
        </div>
      </div>

      <div v-else class="vx-row mb-4">
        <div class="vx-col sm:w-1/1 w-full mb-3 text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mt-3"
            @click="conferenciaDeValores('update')"
            >Atualizar</vs-button
          >
          <vs-button
            v-if="cobrancasFechamento.length > 0"
            color="success"
            class="mt-3"
            @click="modalConfirmo = true"
            >Gerar Cobranças</vs-button
          >
        </div>
      </div>
    </div>

    <Modal
      id="testepopup"
      name="testepopup"
      class="holamundo"
      title="Confirmar Geração de Orderm de Cobranças"
      :active.sync="modalConfirmo"
    >
      <div class="flex flex-col items-center">
        <span class="font-bold"
          >Tem certeza de que deseja gerar as cobranças?</span
        >
        <span class="font-bold"
          >Essa ação é irreversível e não pode ser desfeita.</span
        >
      </div>
      <div class="vx-row mt-4">
        <div class="vx-col sm:w-1/1 w-full flex gap-4 justify-center">
          <vs-button
            color="warning"
            type="border"
            @click="modalConfirmo = false"
            >Cancelar</vs-button
          ><vs-button color="success" @click="gerarCobrancas"
            >Gerar Cobranças</vs-button
          >
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import locale from './../../../../locale';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import * as lang from 'vuejs-datepicker/src/locale';
import service from '../../../../services';
import BotaoSubmit from './../../../../components/BotaoSubmit';
import jwt from 'jsonwebtoken';
import functions from '../../../../utils/functions';
import notify from '../../../../utils/notify';
import utilsList from '../../../../utils/list';

// Components
import AlertNoneRateios from './components/alert-none-rateios.vue';
import AlertConsolidado from './components/alert-consolidado.vue';
import ErrorsAlert from '../../../../components/ErrorsAlert.vue';
import Modal from '../../../../components/Modal.vue';

export default {
  name: 'form-fechamento',
  props: ['dados'],
  components: {
    BotaoSubmit,
    Datepicker,
    AlertNoneRateios,
    AlertConsolidado,
    ErrorsAlert,
    Modal
  },
  data() {
    return {
      habilitarDatasReferencias: true,
      language: 'br',
      languages: lang,
      modalCritica: false,
      titleCritica: '',
      idCriticaResult: null,
      passo: 0,
      passoAtual: null,
      aguardeCadastro: false,
      dadosEmpresa: null,
      criticas: [],
      cobrancasFechamento: [],
      carteirasCobranca: [],
      diasVencimento: [],
      resultadoCritica: [],
      statusApolice: [],
      formCadastro: {
        idFechamento: null,
        idCarteiraCobranca: null,
        mesReferenciaCobranca: null,
        mesVencimentoCobranca: null,
        statusApolicesParticipantes: [],
        diasVencimento: [],
        cadastrosAte: null,
        data_geracao_cobrancas: null,
      },
      idEmpresa: null,
      consolidado: null,
      novoFechamento: {},
      modalConfirmo: false,
      formataDataHoraPadraoBR: functions.formataDataHoraPadraoBR,
      validateState: utilsList.validateState,
      validateStateClass: utilsList.validateStateClass,
      disabledDates: {
        to: null,
      },
    };
  },
  watch: {
    passo: function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.$validator.validateAll();
      }
    },
    dados() {
      this.$validator.reset();
      this.preencheForm();
    },
    'formCadastro.mesReferenciaCobranca': function (newValue) {
      const mesReferencia = newValue.substring(0, 8);
      this.disabledDates.to = new Date(mesReferencia + '02');
    },
  },
  computed: {
    errors() {
      return this.$validator.errors.all();
    },
    cobrancasGeradas() {
      return this.formCadastro.data_geracao_cobrancas ? true : false;
    },
  },
  methods: {
    closeModais() {
      this.modalCritica = false;
    },
    formataMesAno(mesAno) {
      let dataAmericana = new Date('01/' + mesAno);
      return new Date(moment(dataAmericana).format('DD/MM/YYYY'));
    },
    preencheForm() {
      if (this.dados.id) {
        this.formCadastro.idFechamento = this.dados.id;
        this.formCadastro.idCarteiraCobranca = this.dados.carteira_cobranca_id;
        this.formCadastro.mesReferenciaCobranca = this.formataMesAno(
          this.dados.mes_referencia_cobranca,
        );
        this.formCadastro.mesVencimentoCobranca = this.formataMesAno(
          this.dados.mes_vencimento_cobranca,
        );
        this.formCadastro.cadastrosAte = new Date(
          this.dados.cadastrados_ate.replace('Z', ''),
        );
        this.formCadastro.diasVencimento =
          this.dados.vencimentos_apolices.split(',');
        this.formCadastro.statusApolicesParticipantes =
          this.dados.status_apolice_participantes.split(',').map((s) => +s);
        this.passoAtual = this.dados.passo;
        this.passo = this.dados.passo;

        if (this.dados.critica) {
          this.criticas = JSON.parse(this.dados.critica);
        }

        this.cobrancasFechamento = this.dados.cobrancas;
        this.consolidado = this.dados.consolidado
          ? JSON.parse(this.dados.consolidado)
          : null;
        this.formCadastro.data_geracao_cobrancas =
          this.dados.data_geracao_cobrancas;

        this.novoFechamento.status_apolice_participantes =
          this.dados.status_apolice_participantes;
        this.novoFechamento.vencimentos_apolices =
          this.dados.vencimentos_apolices;
        this.novoFechamento.cadastrados_ate = this.dados.cadastrados_ate;
      } else {
        this.resetForm();
      }
    },
    resetForm() {
      this.passo = 0;
      this.passoAtual = 0;
      this.formCadastro.idFechamento = null;
      this.formCadastro.idCarteiraCobranca = null;
      this.formCadastro.mesRefenciaEventos = null;
      this.formCadastro.mesReferenciaCobranca = null;
      this.formCadastro.mesVencimentoCobranca = null;
      this.formCadastro.valorTotalEventos = null;
      this.formCadastro.valorForcadoTodos = null;
      this.formCadastro.diasVencimento = [];
      this.formCadastro.statusApolicesParticipantes = [];
      this.formCadastro.totalCotas = null;
      this.formCadastro.cadastrosAte = null;
      this.formCadastro.data_geracao_cobrancas = null;
    },
    buscaDadosSelectsPorEmpresa(model, array, campoDescricao, campoPK) {
      service
        .getAll('g', {}, `${model}/list/idEmpresa/idEmpresa=${this.idEmpresa}`)
        .then((res) => {
          res.data.forEach((element) => {
            element.id = element[campoPK];
            element.label = element[campoDescricao];
            this[array].push(element);
          });
        });
    },
    exibeResultadoCritica(item) {
      this.titleCritica = item.tipo;
      this.idCriticaResult = item.idCritica;
      this.formCadastro.idEmpresa = this.dadosEmpresa[0].idEmpresa;

      if (this.formCadastro.idEmpresa) {
        this.$vs.loading();
        service
          .post('Fechamentos', 'resultado-critica', {
            ...this.novoFechamento,
            idCritica: item.idCritica,
          })
          .then((res) => {
            this.resultadoCritica = res.data;
          })
          .catch(() => {
            notify.notifyFail(this.$vs, 'Não foi possível buscar Dados');
          })
          .finally(() => {
            this.aguardeCadastro = false;
            this.$vs.loading.close();
          });
      }
    },
    conferenciaDeValores(update) {
      if (this.formCadastro.idEmpresa) {
        this.$vs.loading();
        service
          .post('Fechamentos', 'conferencia-valores', this.formCadastro)
          .then((res) => {
            this.passoAtual = 2;
            this.passo = 2;
            this.consolidado = res.data.consolidado;
            this.cobrancasFechamento = res.data.cobrancas;

            if (update === 'update') {
              notify.notifySuccess(
                this.$vs,
                'Cobranças atualizadas com sucesso!',
              );
            }
          })
          .catch(() => {
            notify.notifyFail(this.$vs, 'Não foi possível buscar Dados');
          })
          .finally(() => {
            this.aguardeCadastro = false;
            this.$vs.loading.close();
          });
      }
    },
    async gerarCobrancas() {
      try {
        await service.post(
          'Fechamentos',
          'gerar-lancamentos-financeiros',
          this.formCadastro,
        );
        this.$emit('concluido');
        notify.notifySuccess(
          this.$vs,
          'Ordem de cobranças gerada com sucesso!',
        );
      } catch (error) {
        notify.notifyFail(
          this.$vs,
          'Falha a gerar a ordem de cobrança, por favor tente novamente.',
        );
      } finally {
        this.aguardeCadastro = false;
        this.modalConfirmo = false;
        this.$vs.loading.close();
      }
    },
    async buscaDadosCadastroEmpresa() {
      if (localStorage.getItem('user-token')) {
        try {
          const decoded = jwt.decode(localStorage.getItem('user-token'));
          this.formCadastro.idEmpresa = decoded.id_empresa;
          this.idEmpresa = decoded.id_empresa;

          const { data } = await service.getAll(
            'g',
            {},
            'empresas/list/idEmpresa/' + this.formCadastro.idEmpresa,
          );

          this.dadosEmpresa = data;
          const dias = this.dadosEmpresa[0].diasVencimento.split(',');
          dias.forEach((element) => {
            this.diasVencimento.push({ id: element, label: element });
          });
        } catch (error) {
          notify.notifyFail(this.$vs, e);
        }
      }
    },
    async buscarStatusApolice() {
      try {
        const { data } = await service.getAll(
          'Fechamentos',
          null,
          'status-apolice-fechamento',
        );

        this.statusApolice = data;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      }
    },
    onSubmit() {
      let [data, hora] = moment(this.formCadastro.cadastrosAte)
        .format('yyyy-MM-DD HH:MM:SS')
        .split(' ');

      // cadastrados até o fim do dia da data selecionada
      hora = '23:59:59';
      const _cadastrosAte = `${data} ${hora}`;

      const referenciasValidas = this.validarDatasReferencias();
      if (referenciasValidas.length > 0) {
        notify.notifyFail(this.$vs, referenciasValidas);
        return;
      }

      this.resultadoCritica = [];
      this.formCadastro.idEmpresa = this.idEmpresa;

      var action = 'atualizar';
      var msgRetorno = 'Dados Atualizados com sucesso';
      if (!this.formCadastro.idFechamento) {
        action = 'adicionar';
        msgRetorno = `Registro Adicionado com sucesso`;
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$vs.loading();
          this.aguardeCadastro = true;

          const _formCadastro = {
            ...this.formCadastro,
            cadastrosAte: _cadastrosAte,
          };

          service
            .post('Fechamentos', action, _formCadastro)
            .then((res) => {
              this.novoFechamento = res.data;
              this.formCadastro.idFechamento = res.data.id;
              this.criticas = JSON.parse(res.data.critica);
              this.passo = res.data.passo;
              this.passoAtual = this.passo;

              notify.notifySuccess(this.$vs, msgRetorno);
            })
            .catch((error) => {
              notify.notifyFail(this.$vs, error);
            })
            .finally(() => {
              this.$vs.loading.close(), (this.aguardeCadastro = false);
            });
        }
      });
    },
    onReset(evt) {
      evt.preventDefault();
      this.resetForm();
      this.$nextTick(() => {
        this.show = true;
      });
    },
    validarDatasReferencias() {
      let msgErro = '';
      const competenciaBoleto = this.formCadastro.mesReferenciaCobranca;
      const mesVencimentoCobranca = this.formCadastro.mesVencimentoCobranca;
      const diasVencimento = this.formCadastro.diasVencimento;

      if (diasVencimento.length === 0) {
        msgErro = 'Selecione os dias de vencimento';

        return msgErro;
      }

      const dataAtual = moment();
      //verifica se a data de vencimento é maior que o dia corrente
      // retorna false se algum dia de vencimento for menor que o dia atual
      const diasVencimentoPosteriorDiacorrente = diasVencimento.reduce(
        (acc, dia) => {
          const arrayControleVencimentos = [];
          const ajusteDia = dia - 1;
          const diaVencimento = moment(mesVencimentoCobranca).add(
            ajusteDia,
            'days',
          );
          arrayControleVencimentos.push(diaVencimento.isAfter(dataAtual));
          return (acc = !arrayControleVencimentos.includes(false));
        },
        true,
      );

      if (msgErro.length > 0) {
        return msgErro;
      }

      //verifica se data de vencimento dos boletos é menor que data de competência
      const compBoletoAnterioVencimento = moment(
        competenciaBoleto,
      ).isSameOrBefore(mesVencimentoCobranca)
        ? true
        : false;

      msgErro = compBoletoAnterioVencimento
        ? ''
        : 'A competência dos boletos deve ser menor que o mês de vencimento';

      if (msgErro.length > 0) {
        return msgErro;
      }

      if (!diasVencimentoPosteriorDiacorrente) {
        msgErro =
          'Não é permitido gerar boletos vencidos, ajuste os dias de vencimento';

        return msgErro;
      }

      return msgErro;
    },
    preencheDatasReferencias() {
      const mesReferenciaCobranca = moment(
        this.formCadastro.mesReferenciaCobranca,
      );
      const mesVencimentoCobranca = mesReferenciaCobranca;
      this.formCadastro.mesReferenciaCobranca = mesReferenciaCobranca.format();
      this.formCadastro.mesVencimentoCobranca = mesVencimentoCobranca.format();
      this.habilitarDatasReferencias = false;
    },
  },
  created() {
    this.$validator.localize('ptBr', locale);
  },
  mounted() {
    this.buscaDadosCadastroEmpresa();

    this.buscaDadosSelectsPorEmpresa(
      'empresasCarteiraCobranca',
      'carteirasCobranca',
      'nomeCarteira',
      'idCarteira',
    );
    this.buscarStatusApolice();
  },
};
</script>

<style scoped>
.div-show {
  display: 'block';
}
.div-hide {
  display: none;
}

li.activeChild {
  border-bottom: 1px solid rgba(var(--vs-primary), 1) !important;
}
</style>

<style scoped lang="scss">
.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
  border: 1px solid gray;
  tr td {
    padding: 2px 4px 2px 4px;
    text-align: center;
  }
  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
.vdp-datepicker input {
  width: 100%;
}
</style>
